import { useMemo } from "react";

import { isEqual } from "lodash";

export const useIsDirty = <T>(value: T, nextValue: T) => {
  const isDirty = useMemo(() => !isEqual(value, nextValue), [value, nextValue]);

  return isDirty;
};
